import { Component } from '@angular/core';

@Component({
  selector: 'app-houses-router',
  template: '<router-outlet></router-outlet>'
})

export class HousesRouterComponent { }



// WEBPACK FOOTER //
// ./src/app/houses/houses-router.component.ts